import React from 'react';

export interface PaginationContextValue {
  scrollableRef?: React.RefObject<HTMLElement>;
}

export const PaginationContext = React.createContext<PaginationContextValue>({
  scrollableRef: undefined,
});
export const usePaginationContext = (): PaginationContextValue => {
  return React.useContext(PaginationContext);
};
